import { render, staticRenderFns } from "./aberturaCaixa.vue?vue&type=template&id=1065dcb4"
import script from "./aberturaCaixa.ts?vue&type=script&lang=js&external"
export * from "./aberturaCaixa.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1065dcb4')) {
      api.createRecord('1065dcb4', component.options)
    } else {
      api.reload('1065dcb4', component.options)
    }
    module.hot.accept("./aberturaCaixa.vue?vue&type=template&id=1065dcb4", function () {
      api.rerender('1065dcb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/sessaoCaixa/aberturaCaixa.vue"
export default component.exports